module.exports = __webpack_public_path__ + "media/images/illustrations/monitor-ee4aba7e0ead30be77b76340b2138a2f.svg";